<template>
    <div class="AdminPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-lg-12">
                    <div class="paper">
                        <div class="tab-content col-12">
                            <h2>Admin Console</h2>
                            <b-card-group deck>
                                <b-container fluid>
                                    <b-row>
                                        <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12">
                                            <b-card class="text-center"
                                                    tag="roles"
                                                    style="border:none;">
                                                <font-awesome-icon :icon="['fa', 'users']" style="font-size: 48px;" />
                                                <b-card-title class="mb-0 mt-2">Roles</b-card-title>
                                                <b-card-text>
                                                    Add, modify or delete roles.
                                                </b-card-text>
                                                <router-link to="/Admin/Role" class="stretched-link"></router-link>
                                            </b-card>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12">
                                            <b-card class="text-center"
                                                    tag="permissions"
                                                    style="border:none; border-spacing:0rem">
                                                <font-awesome-icon :icon="['fa', 'address-card']" style="font-size: 48px;" />
                                                <b-card-title class="mb-0 mt-2">Permissions</b-card-title>
                                                <b-card-text>
                                                    Add, modify or delete permissions.
                                                </b-card-text>
                                                <router-link to="/Admin/Permission" class="stretched-link"></router-link>
                                            </b-card>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12">
                                            <b-card class="text-center"
                                                    tag="forms"
                                                    style="border:none;">
                                                <font-awesome-icon :icon="['fa', 'book']" style="font-size: 48px;" />
                                                <b-card-title class="mb-0 mt-2">Forms</b-card-title>
                                                <b-card-text>
                                                    Add, modify or delete forms.
                                                </b-card-text>
                                                <router-link to="/Admin/Forms" class="stretched-link"></router-link>
                                            </b-card>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12">
                                            <b-card class="text-center"
                                                    tag="memberships"
                                                    style=" border:none;">
                                                <font-awesome-icon :icon="['fa', 'key']" style="font-size: 48px;" />
                                                <b-card-title class="mb-0 mt-2">Memberships</b-card-title>
                                                <b-card-text>
                                                    Add, modify or delete memberships.
                                                </b-card-text>
                                                <a href="#" class="stretched-link"></a>
                                            </b-card>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12">
                                            <b-card class="text-center"
                                                    tag="users"
                                                    style="border:none;">
                                                <font-awesome-icon :icon="['fa', 'user']" style="font-size: 48px;" />
                                                <b-card-title class="mb-0 mt-2">Users</b-card-title>
                                                <b-card-text>
                                                    Add, modify or delete users.
                                                </b-card-text>
                                                <router-link to="/Admin/User" class="stretched-link"></router-link>
                                            </b-card>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12">
                                            <b-card class="text-center"
                                                    tag="settings"
                                                    style="border:none;">
                                                <font-awesome-icon :icon="['fa', 'cogs']" style="font-size: 48px;" />
                                                <b-card-title class="mb-0 mt-2">Settings</b-card-title>
                                                <b-card-text>
                                                    Add, modify or delete settings.
                                                </b-card-text>
                                                <router-link to="/Admin/Settings" class="stretched-link"></router-link>
                                            </b-card>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12">
                                            <b-card class="text-center"
                                                    tag="settings"
                                                    style="border:none;">
                                                <font-awesome-icon :icon="['fa', 'notes-medical']" style="font-size: 48px;" />
                                                <b-card-title class="mb-0 mt-2">Welligent</b-card-title>
                                                <b-card-text>
                                                    Perform Welligent Sync Operations
                                                </b-card-text>
                                                <router-link to="/Admin/Welligent" class="stretched-link"></router-link>
                                            </b-card>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12">
                                            <b-card class="text-center"
                                                    tag="settings"
                                                    style="border:none;">
                                                <font-awesome-icon :icon="['fa', 'network-wired']" style="font-size: 48px;" />
                                                <b-card-title class="mb-0 mt-2">Distribution Lists</b-card-title>
                                                <b-card-text>
                                                    Add, modify or delete Distribution Lists
                                                </b-card-text>
                                                <router-link to="/Admin/DistributionLists" class="stretched-link"></router-link>
                                            </b-card>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12">
                                            <b-card class="text-center"
                                                    tag="settings"
                                                    style="border:none;">
                                                <font-awesome-icon :icon="['fa', 'cloud']" style="font-size: 48px;" />
                                                <b-card-title class="mb-0 mt-2">Hosted Files</b-card-title>
                                                <b-card-text>
                                                    Add, modify or delete Hosted Files
                                                </b-card-text>
                                                <router-link to="/Admin/HostedFiles" class="stretched-link"></router-link>
                                            </b-card>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12">
                                            <b-card class="text-center"
                                                    tag="settings"
                                                    style="border:none;">
                                                <font-awesome-icon :icon="['fa', 'ticket-alt']" style="font-size: 48px;" />
                                                <b-card-title class="mb-0 mt-2">IP Restrictions</b-card-title>
                                                <b-card-text>
                                                    Add, modify or delete IP Restrictions
                                                </b-card-text>
                                                <router-link to="/Admin/IPRestrictions" class="stretched-link"></router-link>
                                            </b-card>
                                        </b-col>
                                    </b-row>
                                </b-container>

                            </b-card-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import services
    import { UserAPI } from '../../services/api/Core/UserAPI.js';
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faUsers } from '@fortawesome/free-solid-svg-icons';
    library.add(faUsers);
    import { faAddressCard } from '@fortawesome/free-solid-svg-icons';
    library.add(faAddressCard);
    import { faBook } from '@fortawesome/free-solid-svg-icons';
    library.add(faBook);
    import { faKey } from '@fortawesome/free-solid-svg-icons';
    library.add(faKey);
    import { faUser } from '@fortawesome/free-solid-svg-icons';
    library.add(faUser);
    import { faCogs } from '@fortawesome/free-solid-svg-icons';
    library.add(faCogs);
    import { faCloud } from '@fortawesome/free-solid-svg-icons';
    library.add(faCloud);
    import { faNotesMedical } from '@fortawesome/free-solid-svg-icons';
    library.add(faNotesMedical);
    import { faNetworkWired } from '@fortawesome/free-solid-svg-icons';
    library.add(faNetworkWired);
    import { faTicketAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTicketAlt);
    export default {
        name: "AdminPane",
        created() {
            const userAPI = new UserAPI(this.$baseURL);
            this.userAPI = userAPI;
        },
        props: [],
        methods: {
            ChangePaneShown(paneName) {
                //loop through Panes shown and flip true/false values
                this.PanesShown = paneName;
            },
            CloseChildRecord: function (spmID) {
                if (this.PanesShown == spmID) {
                    this.ChangePaneShown("NotificationSettings");
                }
                this.$store.commit("Clients.ClientProfiles.Remove", spmID);
            }
        },
        components: {
        }
    }
</script>

<style scoped>
    .mt-2{
        white-space: nowrap;
        overflow: hidden;
    }
    .card-body{
        display:table;
    }

    .AdminPane {
        background-color: #605271;
    }
</style>